import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import styles from './index.module.scss'
import { Button, Divider, Empty, Image, Input, message, Select, Space, Spin, Checkbox, Radio } from 'antd'
import Utils from "@/utils/utils"
import Iconfont from '@/utils/Iconfont';
import { AppContext } from '@utils/AppContext';
import { downloadWhitelist } from '@/utils/CONST'

const DeliveryImageItem = ({
    item,
    onPreview,
    isImageMultiSelect,
    selectImageKeys,
    onSelect,
    onPass,
    onDownload,
}) => {
    const { globalUser } = useContext(AppContext)
    const isVideo = useMemo(() => {
        return isVideoUrl(item.url)
    }, [item])
    // 批量操作下，是否禁用选择
    const multiSelectDisabled = useMemo(() => {
        if (isImageMultiSelect == 'download') {
            if (downloadWhitelist.includes(globalUser.mobile)) return false
            return !(item?.status == 2 && !!item?.deliverySubmit)
        }
        return (item?.deliverySubmit && (item?.status == 2 || item?.status == -1))
    }, [item, isImageMultiSelect, globalUser])
    const handleClick = useCallback(() => {
        if (isImageMultiSelect) {
            if (multiSelectDisabled) return
            onSelect(item)
        } else {
            onPreview({
                imageId: item.imageId,
                skuId: item.skuCode || item.skuNumber, // 没填商品货号，使用skuNumber作为skuid
            })
        }            
    }, [isImageMultiSelect, multiSelectDisabled, onSelect, onPreview, item])
    const passActive = useMemo(() => {
        return item.status == 2
    }, [item])
    const passActiveAndUnSubmited = useMemo(() => {
        return passActive && !item.deliverySubmit
    }, [passActive, item])
    const canDownload = useMemo(() => {
        if (!passActive) return false
        return !!item.deliverySubmit || downloadWhitelist.includes(globalUser.mobile)
    }, [passActive, item, globalUser])
    return (
        <div
            className={`${styles.DeliveryImageItem} ${isImageMultiSelect ? styles.MultiSelect : ''}`}
            onClick={handleClick}
        >
        {
            isVideo ?
            <Image
                rootClassName={styles.ImageItem}
                style={{cursor:"pointer"}}
                src={Utils.getVideoSnapshot(item.url)}
                alt="sku"
                fallback={require('@assets/images/fallback.png')}
                preview={false}
            /> :
            <Image
                rootClassName={styles.ImageItem}
                style={{cursor:"pointer"}}
                src={Utils.getImgThumbnail(item.url)}
                alt="sku"
                fallback={require('@assets/images/fallback.png')}
                preview={false}
            />
        } {
            item.status == 2 && item.isDownload ? <span className={`${styles.Status} ${styles.Downloaded}`}>已下载</span> :
            item.status == 2 && !item.isDownload ? <span className={`${styles.Status} ${styles.Passed}`}>已通过</span> :
            item.status == 3 ? <span className={`${styles.Status} ${styles.FineTuning}`}>不通过</span> :
            item.status == -1 ? <span className={`${styles.Status} ${styles.Canceled}`}>已取消</span> :
            item.refine ? <span className={`${styles.Status} ${styles.FineTuned}`}>待复验</span> : 
            <span className={`${styles.Status} ${styles.WaitCheck}`}>待验收</span>
        } {
            (isImageMultiSelect && !multiSelectDisabled) ? 
            <Checkbox
                className={styles.Checkbox}
                checked={selectImageKeys.includes(item.imageId)}
            /> : null
        } {
            <div className={styles.HoverMask} onClick={handleClick}>
                <Iconfont type="icon-larger" className={styles.PreviewIcon} />
            {
                canDownload ?
                <button
                    className={styles.PassButton}
                    onClick={(e) => {
                        e.stopPropagation();
                        onDownload?.(item)
                    }}
                >
                    下载
                </button> :
                item.status == -1 ?
                null :
                <button
                    className={styles.PassButton}
                    style={passActiveAndUnSubmited ? {display:"none"} : null}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (!passActive) onPass(item.imageId, item.status == 3 || item.status == -1)
                    }}
                >
                    通过
                </button>
            }
            </div>
        }
        </div>
    )
}

export default DeliveryImageItem

// 常见视频扩展名，用于判断 url 是否为视频资源
const VIDEO_EXTENSIONS = /\.(mp4|webm|ogg|mov|avi|mkv|flv|wmv|m4v)(\?|$)/i

/** 根据 url 扩展名判断是否为视频 */
function isVideoUrl(url) {
    if (!url) return false
    return VIDEO_EXTENSIONS.test(url)
}
